var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUserAdd32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11a3.75 3.75 0 117.5 0A3.75 3.75 0 016 11zm6 0a2.25 2.25 0 10-4.5 0 2.25 2.25 0 004.5 0zm17.75 3.25a7 7 0 11-14 0 7 7 0 0114 0zm-7-3.75a.75.75 0 01.743.648l.007.102v2.25h2.25a.75.75 0 01.102 1.493L25.75 15H23.5v2.25a.75.75 0 01-1.493.102L22 17.25V15h-2.25a.75.75 0 01-.102-1.493l.102-.007H22v-2.25a.75.75 0 01.75-.75zm-13 5.75A6.75 6.75 0 003 23c0 .627.172 1.246.506 1.849a1.75 1.75 0 001.53.901h9.427a1.75 1.75 0 001.53-.9c.335-.602.507-1.222.507-1.85a6.75 6.75 0 00-6.75-6.75zm0 1.5c2.9 0 5.25 2.35 5.25 5.25 0 .363-.103.734-.319 1.122a.25.25 0 01-.218.128H5.036a.25.25 0 01-.218-.129C4.603 23.734 4.5 23.363 4.5 23c0-2.9 2.35-5.25 5.25-5.25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserAdd32);
export default __webpack_public_path__ + "static/media/icon-user-add-32.c5537856.svg";
export { ForwardRef as ReactComponent };